<script>
import SimpleDataSelectFilter from "@/views/DataSelect/Components/SimpleDataSelectFilter.vue";
import {useDataSelectStore} from "@/stores/DataSelect.js";
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {watch} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import useSharedSelectData from "@/use/SharedSelectData";
import axios from "axios";

export default {
    components: {SimpleDataSelectFilter},
    props: {
        externType: String
    },
    setup(props) {
        const {
            total,
            loading,
            page,
            filter,
        } = useSharedData();

        const {getDataSelectName, transformFilterValues} = useSharedMethod();

        const {dataSelectModules} = useSharedSelectData();

        const {$i18n, $router, $route} = useTools();

        const dataSelectStore = useDataSelectStore();
        const securityStore = useSecurityStore();
        filter.value.allRecords = true;
        filter.value.type = props.externType;

        const headers = [
            {
                text: "...",
                align: "left",
                sortable: true,
                value: "action"
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                sortable: true,
                value: "code",
            },
            {
                text: $i18n.t("common.label"),
                align: "left",
                sortable: true,
                value: "name",
            },
            {
                text: $i18n.t("data_select.type"),
                align: "left",
                sortable: true,
                value: "type",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_GENERAL_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: props.externType ? `${$route.name}.edit` :  'data_selects.edit', params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_GENERAL_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: props.externType ? `${$route.name}.delete` :  'data_selects.delete', params: { id: item.id }})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/dataSelects', {params: transformFilterValues(filter.value)}).then((response) => {
                dataSelectStore.setDataSelects(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => filter.value, () => {
            page.value = 1;
            findAll();
        }, {deep: true, immediate: true});

        watch(() => props.externType, () => {
            filter.value.type = props.externType;
            page.value = 1;
            findAll();
        });

        return {
            dataSelectStore,
            securityStore,
            headers,
            actions,
            total,
            loading,
            filter,
            dataSelectModules,
            getDataSelectName,
            findAll,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="externType ? $t(`data_select.${externType}`) : $t('module.data_selects')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_GENERAL_PARAM']"
                    @press="$router.push({ name: externType ? `${$route.name}.add` :  'data_selects.add' })"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <simple-data-select-filter :filter="filter" :show-type="!externType"/>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="dataSelectStore.dataSelects"
                    :total="total"
                    sort-by="name"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:[`item.type`]="{ item }">
                        <w-inline-text :text="getDataSelectName(item.type, dataSelectModules)"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
